import { complexSlider, showComplexSlider, complexFaq, complexFilterSpecificSlide, locationSearch } from './components/misc';

const complexLotLogic = {
    init: function () {
        document.addEventListener('DOMContentLoaded', () => {
            this.showMap();
            this.filter();
            this.lots();
            this.lotsSliderInit();
            this.locationSelect();
            complexSlider();
            showComplexSlider();
            complexFaq();
            complexFilterSpecificSlide();
            locationSearch();
        });
    },

    showMap: function () {
        var isComplexPage = !(document.querySelector("#filter-result") && document.querySelector("#filter-map"));
        if (isComplexPage) {
            var isSortHidden = !document.querySelector("#filter-result");
            if (isSortHidden) $('#sort-by-filter').css('display', 'none');
            return;
        }
        var showFlag = !!document.querySelector("#filter-result");
        $('.show-map').on('click', function (event) {
            switch (showFlag) {
                case true:
                    $('#sort-by-filter').css('display', 'none');
                    $('.complex-map').addClass('show');
                    $('.complex-list').addClass('hidden');
                    $('.complex-map').removeClass('hidden');
                    $('.complex-list').removeClass('show');
                    $('.complex-list').addClass('transparent');
                    $('.complex-map').css('display', 'block');
                    setTimeout(function () {
                        $('.complex-list').css('display', 'none');
                    }, 700);
                    showFlag = false;
                    break;
                case false:
                    $('#sort-by-filter').css('display', 'block');
                    $('.complex-map').addClass('hidden');
                    $('.complex-list').addClass('show');
                    $('.complex-map').removeClass('show');
                    $('.complex-list').removeClass('hidden');
                    setTimeout(function () {
                        $('.complex-map').css('display', 'none');
                        $('.complex-list').css('display', 'block');
                    }, 340);
                    showFlag = true;
                    break;
                default:
                    return;
            }

            $(this).find('.complexes-filter__txt').toggle();
        });
    },

    filter: function () {
        if (!$('#filter').length) {
            return;
        }

        let filter = new Filter({
            filterBlockSelector: '#filter, #more-filters-popup',
            filterResultSelector: '#filter-result',
            filterFoundSelector: '#filter-found',
            showSelector: '.showIfComplexes',
            loadMoreBtnSelector: '#load-more',
            filterShowBtnSelector: '.show-results',
            toggleMapBtnSelector: '.show-map',
            filterMapResultSelector: '#filter-map',
            tagsBlockSelector: '.filter__under-row .filter__tags',
            callBack: function () {
                complexSlider();
                main.mobileSliderShow();
                complexLotLogic.lotsSliderInit();
            }
        });

        filter.isActiveFilterCallback = function (el) {
            if (el.parents('[data-price]').length) {
                if ($('[name="data-type-filter-price"]:checked').val() !== el.parents('[data-price]').data('price')) {
                    return false;
                }
            }

            if (el.parents('.filter-metro[data-type]').length) {
                if ($('[name="metro-distance"]:checked').val() !== el.parents('[data-type]').data('type')) {
                    return false;
                }
            }

            if (!el.parents('#created-dynamic-filters').length) {
                if (el.data('checkbox-check-like-this') !== undefined) {
                    if (el.parents('#more-filters-popup').length) {
                        return el.parents('#more-filters-popup').is(':visible');
                    } else {
                        return $('#more-filters-popup').is(':hidden');
                    }
                } else {
                    return true;
                }
            } else {
                return true;
            }
        };

        filter.filterBlock.find('input:not([data-ignore-filter])').change(function () {
            filter.sendFilter();
        });

        $(document).on('locations-saved', function () {
            filter.sendFilter();
        })
    },

    lots: function() {
        let pageLotId = $('.lots-main').data('id');
        let subscribeData = JSON.parse(localStorage.getItem('subscribe_data'));

        if (pageLotId) {
            if (subscribeData && subscribeData.lots.includes(pageLotId.toString())) {
                $('#no-subscribe-price').hide();
                $('#signed-price').show();
                $('#unsubscribe-price').find('[name="email"]').val(subscribeData.email);
                $('#unsubscribe-price').find('b').text(subscribeData.email);
            } else {
                $('#no-subscribe-price').show();
                $('#signed-price').hide();
            }
        }


        // begin wishlist
        var wishColumn = $('.wishlist-popup__items'),
            wishExample = $('.wishlist-popup__item_example'),
            wishlistArr = getWishList();

        if ($('.add-whishlist').length) {
            $('.add-whishlist').each(function() {
                if (wishlistArr.includes($(this).data('id'))) {
                    $(this).addClass('active');
                }
            });
        }

        $(document).on('click', '.add-whishlist', function() {
            wishlistArr = getWishList();

            if (!$(this).hasClass('active')) {
                addWhishlist($(this));

                $(this).addClass('active');
            } else {
                removeWhishlist($(this));
                $(this).removeClass('active');
            }
        });

        $(document).on('click', '.lots-card__delete-btn', function(){
            removeWhishlist($(this).closest('.lots-card'));
        });

        $(document).on('click', '.wishlist__clear', function(e) {
            e.preventDefault();
            removeWhishlist();
        });

        function getWishList() {
            return localStorage.getItem('wishlist') ? JSON.parse(localStorage.getItem('wishlist')) : [];
        }

        function addWhishlist(lot) {
            var wishItem = wishExample.clone();
            wishItem.find('.lots-card__text-date').text(`
                ${getCurrentTime().hour}:${getCurrentTime().minute}, ${getCurrentTime().day} ${main.months[gInitialData.lang][getCurrentTime().month]} ${getCurrentTime().year}
            `);
            wishItem.find('.lots-card__text-info').text(`
                ${lot.data('rooms')}, ${lot.data('area')}
            `);
            wishlistArr.push(lot.data('id'));
            wishlistArr = Array.from(new Set(wishlistArr));
            localStorage.setItem('wishlist', JSON.stringify(wishlistArr));
            wishItem.removeClass('wishlist-popup__item_example').prependTo(wishColumn).addClass('show');

            setTimeout(function() {
                wishItem.addClass('hidden');
                setTimeout(function() {
                    wishItem.remove();
                }, 600);
            }, 3000);
        }

        function removeWhishlist(item) {
            if (item) {
                wishlistArr.splice(wishlistArr.indexOf(item.data('id')), 1);

                if ($('.wishlist__count').length) {
                    var countChoice = $('.wishlist__count').data('choice').split('|');
                    $('.wishlist__count').text(wishlistArr.length + ' ' + transChoice(wishlistArr.length, countChoice));
                    item.remove();
                }

            } else {
                clearWishlist();
            }
            localStorage.setItem('wishlist', JSON.stringify(wishlistArr));

            if(wishlistArr.length < 1) {
                clearWishlist();
            }
        }

        function clearWishlist() {
            wishlistArr = [];
            $('.wishlist__column').empty();
            $('.wishlist__center').show();
        }

        function getCurrentTime() {
            var date = new Date();
            return {
                year: dateFormatting(date.getFullYear()),
                month: dateFormatting(date.getMonth()),
                day: dateFormatting(date.getDate()),
                hour: dateFormatting(date.getHours()),
                minute: dateFormatting(date.getMinutes())
            };

            function dateFormatting(num) {
                return num.length < 2 ? '0' + num : num;
            }
        }

        $('.wishlist-popup').on('click', '.wishlist-popup__close', function() {
            $(this).closest('.wishlist-popup__item').remove();
        });

        if ($('.wishlist__container').length) {
            var data = {
                lots: JSON.stringify(wishlistArr)
            };
            $.ajax({
                url: $('.wishlist__container').data('action'),
                method: 'get',
                data: data,
                complete: function (jqXHR) {
                    if (jqXHR.status !== 200) {//При успешной отправке формы сервер должен отвечать: echo json_encode({"status":"form_sent_ok"}); Кроме status можно добавить другие данные
                        alert('Кажется, что-то пошло не так. Повторите попытку позднее, спасибо.');
                        return false;
                    }
                    $('.wishlist__container').removeClass('waiting');
                    $('.wishlist__container').append(jqXHR.responseText);
                    complexLotLogic.lotsSliderInit();
                }
            });
        }
        // end wishlist

        $('.lots-main__share').on('click', function(event) {
            if ($(window).width() < 768) {
                popupActions.popupShow('modal-share');
                return;
            }

            if (!event.target.closest('.lots-main__tooltip')) {
                $(this).toggleClass('active');
            }
        });

        $('#modal-share button, #modal-share a').on('click', function() {
            popupActions.popupClose('#modal-share');
        });

        $(document).on('click', function(event) {
            if (!event.target.closest('.lots-main__share')) {
                $('.lots-main__share').removeClass('active');
            }
        });

        $('.lots-main__tooltip-item_copy').on('click', function() {
            copyToClipboard(window.location.href);
        });

        $('.modal__share-copy').on('click', function() {
            copyToClipboard(window.location.href);
        });

        $('.lots-main__tooltip button, .lots-main__tooltip a').on('click', function() {
            $(this).closest('.active').removeClass('active');
        });

        function initFinishGallerySlider(slider) {
            let finishingGallerySlider = slider.flickity({
                pageDots: false,
                prevNextButtons: false,
                contain: true,
                wrapAround: true,
            });

            $('.finishing__gallery-btn').on('click', function() {
                switch (true) {
                    case $(this).hasClass('finishing__gallery-btn_left'):
                        finishingGallerySlider.flickity('previous');
                        break;
                        case $(this).hasClass('finishing__gallery-btn_right'):
                        finishingGallerySlider.flickity('next');
                        break;
                }
            });
        }

        $('.finishing__tiles-btn').on('click', function() {
            $(this).toggleClass('active');
        });

        $(document).on('click', '.lots-card', function(e){
            if (e.target.closest('.add-whishlist') || e.target.closest('a') || e.target.closest('button')) return;
            window.open($(this).find('.lots-card__fat-text a').attr('href'), '_blank');
        });
    },
    
    lotsSliderInit: function () {
        if (!$('.lots-card__item_carousel').length) return;

        if ($(window).width() > 767) {
            $('.lots-card__item_carousel').brazzersCarousel()
        } else {
            let lotsCardSlider = $('.lots-card__item_carousel').flickity({
                pageDots: false,
                cellAlign: 'left',
                contain: true,
                prevNextButtons: false,
            });
        }
    },

    locationSelect: function () {
        // При выборе метро
        $(document).on('click', '[data-select-metro-station]', function() {
            var station = $(this).data('select-metro-station')
        })

        // При выборе района
        $(document).on('click', '[data-select-district]', function() {
            var district = $(this).data('select-district')
        })

        // Кнопка сохранить
        $(document).one('click', '#location-save, .location-save', handleLocationSave)

        // Кнопка очистить
        $(document).on('click', '#location-clear, .filter__tags-clear', function(e) {
            e.preventDefault();
            $('.moscow_metro_map__station, .moscow_metro_map__check').removeClass('active')
            $('.filter__location-content__districts-collection-item input:checked').prop('checked', false).change();
            $('.filter__location-content__metro-stations-item input:checked').prop('checked', false).change();

            var url = new URL(window.location.href)
            var filters = url.searchParams.get('filters');
            filters = (filters) ? filters.split(';') : [];

            filters.forEach(function(filter, i) {
                var split = filter.split('|')

                if (split[0] === 'district_id/int_multiple_filter' || split[0] === 'metro_id/int_multiple_filter') {
                    delete filters[i]
                }
            })

            if (filters.length > 0) {
                url.searchParams.set('filters', filters.join(';'))
                window.history.replaceState({}, document.title, url.toString());
            }
        })

        // Кнопка поиска на главной
        $(document).on('click', '#index-search', function () {
            var metros = getActiveItems('metro-station');
            var districts = getActiveItems('district')

            setLocationInputs('location-metro', metros);
            setLocationInputs('location-district', districts);
        })

        // Хук на монтирование Locations.vue
        $(document).on('locationsMounted', function () {
            setActiveItems();
        })

        /**
         * Обработчик сохранения локаций
         *
         * @return void
         */
        function handleLocationSave(e) {
            e.preventDefault();
            var metros = getActiveItems('metro-station');
            var districts = getActiveItems('district')

            setLocationInputs('location-metro', metros);
            setLocationInputs('location-district', districts);

            // Главная страница
            if ($('#first-screen-filter').length) {
                closeLocationModal(function() {
                    $('#index-search').trigger('click')
                })
            } else {
                closeLocationModal(function() {
                    $(document).trigger('locations-saved');
                    $('body').removeClass('hidden')
                    $('.filter__search.drop-btn').removeClass('active');
                    $('.filter__drop-location').removeClass('drop-show');
                    removeFilterTagOnLocationSelect('metro', metros)
                    removeFilterTagOnLocationSelect('district', districts)
                })
            }

            setTimeout(function () {
                $(document).one('click', '#location-save, .location-save', handleLocationSave)
            }, 1000)
        }

        /**
         * При выборе локаций, убирает теги, которые содержали локации при прошлом фильтре
         *
         * @param type
         * @param location
         */
        function removeFilterTagOnLocationSelect(type, location) {
            var tagIds = [];
            var filterName = (type === 'metro') ? 'metro_id/int_multiple_filter' : 'district_id/int_multiple_filter'

            $('.filter__tags-item[data-filter-name="' + filterName + '"]').each(function (i, tag) {
                var id = $(tag).data('filter-value');
                if (Number.isInteger(id))
                    tagIds.push(id)
            })

            var tagIdsToRemove = tagIds.filter(function(value) {
                return !location.ids.includes(value);
            });

            tagIdsToRemove.forEach(function (id, i) {
                $('.filter__tags-item[data-filter-name="' + filterName + '"][data-filter-value="' + id + '"]').remove()
            })
        }

        /**
         * Возвращает имя последнего класса элемента
         *
         * @param el
         *
         * @return void
         */
        function getLastClassName(el) {
            return $(el).attr('class').split(' ').pop();
        }

        /**
         * Добавляет в DOM тэги фильтра
         *
         * @param type
         * @param values
         *
         * @return void
         */
        function setLocationTags(type, values) {

            values.titles.forEach(function(object) {
                Object.entries(object).forEach(function(entries) {
                    var id = entries[0];
                    var title = entries[1];
                    var filterName = '';
                    var isMetro = type === 'location-metro'
                    var isDistrict = type === 'location-district'

                    if (isMetro) {
                        filterName = 'metro_id/int_multiple_filter'
                    } else if (isDistrict) {
                        filterName = 'district_id/int_multiple_filter'
                    }

                    $(document).trigger('addFilterTag', {
                        text: title,
                        filterName: filterName,
                        filterValue: id,
                        addCloseBtn: true,
                        removeCallback: function() {
                            var url = new URL(window.location.href)
                            var filters = url.searchParams.get('filters');
                            filters = (filters) ? filters.split(';') : [];

                            $(document).trigger('removeFilterTag', {
                                filterName: filterName,
                                filterValue: id
                            });

                            if (isMetro) {
                                var metro = $('label[data-select-metro-station="' + id + '"]');
                                var metro_schema = $('.moscow_metro_map__station text:contains("' + title + '")').parent('.moscow_metro_map__station')
                                var metro_schema_id = metro_schema.data('id');

                                $('.filter__location-content__metro-stations-item input[name="' + filterName + '"][value="' + id + '"]').prop('checked', false).change();
                                $('.moscow_metro_map__station[data-id="' + metro_schema_id + '"]').removeClass('active')
                                $('.moscow_metro_map__check[data-id="' + metro_schema_id + '"]').removeClass('active')

                                filters.forEach(function(filter, i) {
                                    var split = filter.split('|')
                                    filters = clearTagsInFilter(filters, id, 'metro_id/int_multiple_filter')
                                })
                            } else if (isDistrict) {
                                $('.filter__location-content__districts-collection-item input[name="' + filterName + '"][value="' + id + '"]').prop('checked', false).change();
                                filters = clearTagsInFilter(filters, id, 'district_id/int_multiple_filter')
                            }

                            url.searchParams.set('filters', filters.join(';'))
                            window.history.replaceState({}, document.title, url.toString());
                            setTimeout(function() {
                                $(document).trigger('locations-saved');
                            }, 100)
                        }
                    })
                })
            })
        }

        /**
         * Получает заголовки из объекта
         *
         * @param values
         *
         * @return []
         */
        function getTitlesFromObject(values) {
            var titles = [];

            values.titles.forEach(function(object) {
                Object.entries(object).forEach(function(entries) {
                    titles.push(entries[1])
                })
            })

            return titles;
        }

        /**
         * Убирает из фильтра удаленный тег, и возвращает его
         *
         * @param filter
         * @param id
         * @param type
         *
         * @return filter
         */
        function clearTagsInFilter(filters, id, type) {
            filters.forEach(function(filter, i) {
                var split = filter.split('|')

                if (split[0] === type) {
                    var values = split[1].split(':');
                    values.forEach(function(value, j) {
                        if (value == id) {
                            delete values[j]
                        }
                    })

                    var joined_values = values.filter(n => n).join(':');

                    if (type === 'metro_id/int_multiple_filter') {
                        $('#location-metro').val(joined_values)
                    } else if (type === 'district_id/int_multiple_filter') {
                        $('#location-district').val(joined_values)
                    }

                    split[1] = joined_values;
                    filters[i] = split.join('|')
                }
            })

            return filters
        }

        /**
         * Закрывает модальное окно с локациями
         *
         * @param callback
         */
        function closeLocationModal(callback) {
            $('#locations-modal').addClass('hidden')
            setTimeout(function() {
                $('#locations-modal').removeClass('hidden show')
                if (typeof callback !== undefined) {
                    callback()
                }
            }, 300)
            var event = new Event('closeMetroScheme')
            document.dispatchEvent(event)
        }

        /**
         * Устанавливает выбранные значения в инпутах
         *
         * @param type
         * @param values
         */
        function setLocationInputs(type, values) {
            var input = $('#' + type);
            var label = $('label[for="' + type + '"]')

            if (values.ids.length > 0) {
                var titles = getTitlesFromObject(values)

                input.val(values.ids.join(':'))
                label.text(titles.join(', '))
                toggleInput(input, true)

                setLocationTags(type, values)
            } else {
                input.val('')
                label.text('')
                toggleInput(input, false)
            }
        }

        /**
         * Переключает инпут на главной
         *
         * @param input
         * @param value
         */
        function toggleInput(input, value) {
            // Для главной страницы
            if ($('#first-screen-filter').length) {
                input.prop('checked', value).change()
            } else {
                input.prop('checked', value)
            }
        }

        /**
         * Получает выбранные метро, или районы
         *
         * @param type
         * @return {{ids: *[], titles: *[]}}
         */
        function getActiveItems(type) {
            var selector = ''
            var items = {
                ids: [],
                titles: []
            };

            if (type === 'metro-station')
                selector = '.filter__location-content__metro-stations-item input:checked'
            else if (type === 'district')
                selector = '.filter__location-content__districts-collection-item input:checked'

            $(selector).each(function (i, input) {
                var id = parseInt($(input).val())
                var title = $(input).data('title')
                var object = {}

                items.ids.push(id)
                object[id] = title
                items.titles.push(object)
            })

            return items;
        }

        /**
         * Устанавливает из query строки фильтра активные элементы в локациях
         *
         * @return void
         */
        function setActiveItems() {
            var url = new URL(window.location.href)
            var filters = url.searchParams.get('filters');
            filters = (filters) ? filters.split(';') : [];

            filters.forEach(function(filter, i) {
                var split = filter.split('|')
                var key = split[0];
                var values = (split[1]) ? split[1].split(':') : []

                if (key === 'metro_id/int_multiple_filter' && values.length > 0) {
                    values.forEach(function(id) {
                        var metro = $('label[data-select-metro-station="' + id + '"]');
                        var title = metro.parent('.filter__location-content__metro-stations-item').data('title');
                        var metro_schema = $('.moscow_metro_map__station text:contains("' + title + '")').parent('.moscow_metro_map__station')
                        var metro_schema_id = metro_schema.data('id');

                        $('.filter__location-content__metro-stations-item input[name="' + key + '"][value="' + id + '"]').prop('checked', true);
                        $('.moscow_metro_map__station[data-id="' + metro_schema_id + '"]').addClass('active')
                        $('.moscow_metro_map__check[data-id="' + metro_schema_id + '"]').addClass('active')
                    })
                }

                if (key === 'district_id/int_multiple_filter' && values.length > 0) {
                    values.forEach(function(id) {
                        $('.filter__location-content__districts-collection-item input[name="' + key + '"][value="' + id + '"]').prop('checked', true);
                    })
                }
            })

            // Отметить активные станции на схеме метро
            $('.filter__location-content__metro-stations-item [data-select-metro-station]').each(function(i, el) {
                var text = $(el).text().trim();
                $('.moscow_metro_map__station:contains("' + text + '")').addClass('exists')
            })
        }

        setActiveItems();
    },
};


complexLotLogic.init();